<template>

  <v-app-bar app :id="(showAppBar) ? 'app-header-container' : 'app-header-container-splash'">

    <!-- Logged-in view -->
    <template v-if="showAppBar">
      <v-app-bar-nav-icon @click="$root.toggleMainNav" />

      <transition name="fade" appear>
        <v-container fluid class="ma-0 pa-0 app-header">
          <v-row no-gutters>
            <v-col :cols="(showOrgName) ? 4 : 8" class="d-flex align-center justify-start">
              <route-leaf-logo width="100px" linkTo="home" />
            </v-col>
            <v-col cols="4" class="d-flex align-center justify-center" v-if="showOrgName">
              <v-icon :color="(uiType === 'sys-admin') ? '#f8a824' : '#727272'" style="font-size:20px;" class="pr-2">mdi-account-circle-outline</v-icon>
              <div class="app-header-org-name" style="color:#f8a824;" v-if="uiType === 'sys-admin'">{{ appName }} System Admin</div>
              <div class="app-header-org-name" v-else>{{ activeOrg.name }}</div>
            </v-col>
            <v-col cols="4" align="right">
              <user-account-controls />
            </v-col>
          </v-row>
        </v-container>
      </transition>
    </template>

    <!-- Splash page view -->
    <template v-else>
      <transition name="fade-slow" appear>
        <v-container fluid class="app-header">
          <v-row no-gutters>
            <v-col class="pa-0 ma-0 d-flex flex-column align-center justify-center">
              <route-leaf-emblem linkTo="home" />
              <route-leaf-logo class="app-header-logo-splash" linkTo="home" />
            </v-col>
          </v-row>
        </v-container>
      </transition>
    </template>

  </v-app-bar>

</template>

<script>
/* eslint-disable no-unneeded-ternary */
import RouteLeafEmblem from '@/components/app/RouteLeafEmblem'
import RouteLeafLogo from '@/components/app/RouteLeafLogo'
import UserAccountControls from '@/components/app/UserAccountControls'

export default {
  name: 'AppHeader',

  components: {
    RouteLeafEmblem,
    RouteLeafLogo,
    UserAccountControls
  },

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    },
    uiType () {
      return this.$root.uiType()
    },
    isAuthenticatedSession () {
      return this.$store.getters['auth/isAuthenticated']
    },
    activeOrg () {
      return this.$store.getters['auth/activeOrg'] || {}
    },
    showOrgName () {
      const windowWidth = (window) ? window.innerWidth : 1024
      return (windowWidth < 600) ? false : true
    },
    showAppBar () {
      return (
        this.isAuthenticatedSession &&
        this.$route.name !== 'terms-of-use' &&
        this.$route.name !== 'register-receiver-account' &&
        this.$route.name !== 'claim-account' &&
        this.$route.name !== 'accept-invite'
      )
    }
  },

  methods: {
    goToHome () {
      this.$root.goTo('home')
    }
  }
}
</script>

<style>
  #app-header-container-splash .v-toolbar__content {
    height: 130px !important;
    border-bottom: none;
  }

  #app-header-container .v-toolbar__content {
    border-bottom: 1px solid #191919;
    box-shadow: rgba(157, 160, 167, 0.13) 0px 4px 40px;
  }

  .app-header-logo-splash {
    padding-top: 6px !important;
  }

  .app-header-org-name {
    color: #727272;
    font-size: 1.1rem;
  }
</style>
